// extracted by mini-css-extract-plugin
export default {"login":"Login_login__4rE5+","form":"Login_form__xawx9","input":"Login_input__xEN53","loginButton":"Login_loginButton__3rMeJ"};